<span class="badge badge-center rounded-pill bg-success pointer" (click)="openModal()">{{cellValue?.data?.origin_address?.length}}</span>